import { useEffect } from 'react';
import { trackVisit } from '../utils/tracking';

export default function TrackOnMount() {
  useEffect(() => {
    trackVisit().catch(() => {});
  }, []);

  return null;
}
